import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadGlobalParams = () => get(`${url}/parameters`);

const exp = { loadGlobalParams };

export default exp;
